<template>
  <layout-default-filters @apply="$_applyQueryString">
    <template #superior>
      <v-form ref="form">
        <p class="portariachecklist-filtro-label">Data de Cadastro</p>
        <core-date-picker-field
          clearable
          v-model="filters.createdFrom"
          label="De"
        />
        <core-date-picker-field
          clearable
          v-model="filters.createdBefore"
          label="Até"
          :rules="createdBeforeRules"
        />

        <p class="portariachecklist-filtro-label mt-4">Movimento</p>
        <v-radio-group v-model="filters.movimento" hide-details>
          <v-radio
            v-for="opcao in opcoesMovimento"
            :key="opcao.value"
            :label="opcao.label"
            :value="opcao.value"
          />
        </v-radio-group>

        <p class="portariachecklist-filtro-label mt-4">Operação</p>
        <v-radio-group v-model="filters.operacao" hide-details>
          <v-radio
            v-for="opcao in opcoesOperacao"
            :key="opcao.value"
            :label="opcao.label"
            :value="opcao.value"
          />
        </v-radio-group>

        <p class="portariachecklist-filtro-label mt-4">Situação do Checklist</p>
        <v-radio-group v-model="filters.situacaoFormulario" hide-details>
          <v-radio
            v-for="opcao in opcoesSituacaoFormulario"
            :key="opcao.value"
            :label="opcao.label"
            :value="opcao.value"
          />
        </v-radio-group>
      </v-form>
    </template>
  </layout-default-filters>
</template>

<script>
import { GENERIC_QUERIES, PORTARIA_CHECKLIST_QUERIES } from '@/constants/QUERY_FILTERS';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import { PORTARIA_CHECKLIST_STORAGE } from '@/constants/STORAGE';

import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreDatePickerField from '@/components/core/date-picker-field/Index.vue';

function getSession(key, fallback) {
  return sessionStorage.getItem(key) || fallback;
}

function hoje() {
  return new Date().toISOString().substring(0, 10);
}

export default {
  name: 'PortariaChecklistFilters',

  components: {
    LayoutDefaultFilters,
    CoreDatePickerField,
  },

  data() {
    return {
      opcoesMovimento: [
        { value: '', label: 'Todos' },
        { value: 'A', label: 'Aguardando Entrada' },
        { value: 'D', label: 'Dentro da Empresa' },
        { value: 'F', label: 'Saiu da Empresa' },
      ],
      opcoesOperacao: [
        { value: '', label: 'Todos' },
        { value: 'carga', label: 'Carga' },
        { value: 'descarga', label: 'Descarga' },
      ],
      // Padrão (vazio) = pendentes; finalizados saem da fila.
      opcoesSituacaoFormulario: [
        { value: '', label: 'Pendentes' },
        { value: 'nao-iniciado', label: 'Precisa Responder' },
        { value: 'andamento', label: 'Em Andamento' },
        { value: 'finalizado-pendente', label: 'Finalizados Não Enviados' },
        { value: 'conflito', label: 'Conflito no Envio' },
        { value: 'falha', label: 'Falha no Envio' },
      ],
      filters: {
        movimento: getSession(PORTARIA_CHECKLIST_STORAGE.movimento, ''),
        operacao: getSession(PORTARIA_CHECKLIST_STORAGE.operacao, ''),
        createdFrom: getSession(PORTARIA_CHECKLIST_STORAGE.createdFrom, hoje()),
        createdBefore: getSession(PORTARIA_CHECKLIST_STORAGE.createdBefore, hoje()),
        situacaoFormulario: getSession(PORTARIA_CHECKLIST_STORAGE.situacaoFormulario, ''),
      },

      createdBeforeRules: [
        () => {
          if (!this.filters.createdFrom || !this.filters.createdBefore) return true;

          const from = new Date(this.filters.createdFrom);
          const to = new Date(this.filters.createdBefore);
          return to >= from || 'Data Final deve ser superior a Data Inicial';
        },
      ],
    };
  },

  methods: {
    $_applyQueryString() {
      // Só o filtro aplicado fica salvo; a tela o restaura ao voltar para o menu.
      Object.keys(PORTARIA_CHECKLIST_STORAGE).forEach((campo) => {
        sessionStorage.setItem(PORTARIA_CHECKLIST_STORAGE[campo], this.filters[campo] ?? '');
      });

      setQueryValue(GENERIC_QUERIES.page, 1);
      setQueryValue(PORTARIA_CHECKLIST_QUERIES.movimento, this.filters.movimento);
      setQueryValue(PORTARIA_CHECKLIST_QUERIES.operacao, this.filters.operacao);
      setQueryValue(PORTARIA_CHECKLIST_QUERIES.createdFrom, this.filters.createdFrom);
      setQueryValue(PORTARIA_CHECKLIST_QUERIES.createdBefore, this.filters.createdBefore);
      setQueryValue(PORTARIA_CHECKLIST_QUERIES.situacaoFormulario, this.filters.situacaoFormulario);
    },
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.form) this.$refs.form.validate();
        });
      },
    },

    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.filters.movimento = getQueryValue(PORTARIA_CHECKLIST_QUERIES.movimento, this.filters.movimento);
        this.filters.operacao = getQueryValue(PORTARIA_CHECKLIST_QUERIES.operacao, this.filters.operacao);
        this.filters.createdFrom = getQueryValue(PORTARIA_CHECKLIST_QUERIES.createdFrom, this.filters.createdFrom);
        this.filters.createdBefore = getQueryValue(PORTARIA_CHECKLIST_QUERIES.createdBefore, this.filters.createdBefore);
        this.filters.situacaoFormulario = getQueryValue(
          PORTARIA_CHECKLIST_QUERIES.situacaoFormulario,
          this.filters.situacaoFormulario,
        );
      },
    },
  },
};
</script>

<style scoped>
.portariachecklist-filtro-label {
  font-weight: 600;
  margin-bottom: 4px;
}
</style>
